var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDivisionSign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "division sign"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 2.66602C7.26253 2.66602 6.66699 3.26156 6.66699 3.99935C6.66699 4.73714 7.26253 5.33268 8.00033 5.33268C8.73812 5.33268 9.33366 4.73714 9.33366 3.99935C9.33366 3.26156 8.73812 2.66602 8.00033 2.66602Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 10.666C7.26253 10.666 6.66699 11.2616 6.66699 11.9993C6.66699 12.7371 7.26253 13.3327 8.00033 13.3327C8.73812 13.3327 9.33366 12.7371 9.33366 11.9993C9.33366 11.2616 8.73812 10.666 8.00033 10.666Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 7.33268H2.66699V8.66602H13.3337V7.33268Z",
    fill: "#FEFEFE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivisionSign);
export default __webpack_public_path__ + "static/media/division-sign.6201352cafc170dc8a4d0144118ed081.svg";
export { ForwardRef as ReactComponent };